var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.570312,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#ECF9D8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5286 31.377V12.0436C29.5286 10.7089 28.4467 9.62695 27.112 9.62695H15.0286C13.694 9.62695 12.612 10.7089 12.612 12.0436V31.377M29.5286 31.377L31.9453 31.3769M29.5286 31.377H23.487M12.612 31.377L10.1953 31.3769M12.612 31.377H18.6536M17.4453 14.4603H18.6536M17.4453 19.2936H18.6536M23.487 14.4603H24.6953M23.487 19.2936H24.6953M18.6536 31.377V25.3353C18.6536 24.6679 19.1946 24.1269 19.862 24.1269H22.2786C22.946 24.1269 23.487 24.6679 23.487 25.3353V31.377M18.6536 31.377H23.487",
    stroke: "#203202",
    strokeWidth: 1.81306,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.8d197d7c4783b9321ad9d1f95f6a67ca.svg";
export { ForwardRef as ReactComponent };